import styled from 'styled-components';

export const ImageSliderContainer = styled.div`
  display: block;
  height: 100%;
  width: 100%;
  padding-top: 10px;
`;

export const ImageSliderImage = styled.div`
  position: relative;
  display: block;
  width: 100%;
  text-align: center;
  img {
    width: 100%;
    max-width: 700px;
  }
`;

export const ImageSliderBar = styled.div`
  display: inline-block;
  height: 100%;
  width: 100%;
  text-align: center;
  padding: 15px 0;
`;

export const ImageSliderArrowBox = styled.div`
  position: absolute;
  display: inline-block;
  text-align: center;
  margin: auto;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const ImageSliderBarLeft = styled.div`
  display: inline-block;
  height: 0px;
  width: 0px;
  border: solid 100px transparent;
  border-right: solid 30px var(--logo-gray);
  margin: 5px;
  margin-right: 10px;
  transform: translateX(-70%);
  &:hover {
    border-right: solid 30px var(--logo-orange);
    cursor: pointer;
  }
`;

export const ImageSliderBarRight = styled.div`
  display: inline-block;
  height: 0px;
  width: 0px;
  border: solid 100px transparent;
  border-left: solid 30px var(--logo-gray);
  margin: 5px;
  margin-left: 10px;
  transform: translateX(70%);
  &:hover {
    border-left: solid 30px var(--logo-orange);
    cursor: pointer;
  }
`;

export const ImageSliderBarDot = styled.div`
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 5px;
  text-align: center;
  margin: 5px;
  background-color: ${(props) => props.selected ? "var(--logo-orange)" : "var(--logo-gray)"};
  &:hover {
    background-color: var(--logo-orange);
    cursor: pointer;
  }
`;